import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { configActions, storeAction } from '../store/actions'
import { HELPER } from '../utils'

const useLoadMore = (props) => {
	let dispatch = useDispatch()
	const { catalogProduct, storeListing } = props || {}

	const loadMoreStores = () => {
		var isElementInView = HELPER.isScrolledIntoView(
			document.getElementById('flyout-left-container'),
			false
		)
		if (isElementInView) {
			if (catalogProduct) {
				dispatch(configActions.LOAD_MORE_PRODUCTS())
				dispatch(configActions.UPDATE_CURRENT_PRODUCT_PAGE())
			} else if (storeListing) {
				dispatch(storeAction.LOAD_MORE_STORES())
				dispatch(storeAction.UPDATE_CURRENT_STORE_LISTING_PAGE())
			}
		}
	}

	useEffect(() => {
		// window.scrollTo(0,0)
		window.addEventListener('scroll', loadMoreStores)
		return () => {
			window.removeEventListener('scroll', loadMoreStores)
			// storeListing && dispatch(storeAction.CLEAR_PAGE_NUMBER())
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
}

export default useLoadMore
